import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../shared/services/school.service";
import { GroupsService } from "../../services/groups.service";

@Component({
	selector: "app-edit-dynamic-group",
	templateUrl: "./edit-dynamic-group.component.html",
	styleUrls: ["./edit-dynamic-group.component.css", "../../groups.css"],
})
export class EditDynamicGroupComponent implements OnInit {
	constructor(
		private schoolService: SchoolService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private groupService: GroupsService
	) {}

	ngOnInit(): void {
		this.selectedDetails.SchoolID = this.dialogConfig.data.SchoolID;
		this.selectedDetails.EventDynamicGroupID = this.dialogConfig.data.EventDynamicGroupID;
		this.selectedDetails.EventDescShort = this.dialogConfig.data.EventDescShort;
		this.selectedDetails.EventDescriptionID = this.dialogConfig.data.EventDescriptionID;
		this.selectedDetails.DynamicGroupSelectID = this.dialogConfig.data.DynamicGroupSelectID;
		this.selectedDetails.DynamicValueSelectID = Number(this.dialogConfig.data.DynamicValueSelectID);
		this.selectedDetails.AlertSelectID = this.dialogConfig.data.AlertSelectID;
		this.selectedDetails.Exclude = this.dialogConfig.data.Exclude;

		this.loadSchools();
		// this.loadAlertList();
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	InitGroup: any = true;
	InitValue: any = true;
	InitAlert: any = true;

	Saving: any = false;
	SchoolLoading: any = true;
	GroupLoading: any = true;
	ValueLoading: any = true;
	AlertLoading: any = true;

	selectedDetails = {
		SchoolID: 0,
		EventDynamicGroupID: 0,
		EventDescShort: "",
		EventDescriptionID: 0,
		DynamicGroupSelectID: 0,
		DynamicValueSelectID: 0,
		AlertSelectID: 0,
		Exclude: false,
	};

	//Dropdowns
	schoolList: any = [];
	dynamicGroupList: any = [];
	dynamicValueList: any = [];
	alertList: any = [];

	errorMessage: any = "";

	///////////////////////////////////

	///////////////////////////////////
	// Load Data
	///////////////////////////////////

	private loadSchools() {
		this.SchoolLoading = true;

		//
		// Include schools the user doesn't have access to?
		// ex. for a basketball game, include any schools in district
		//
		var result = this.schoolService.loadSchoolList("All");
		result.subscribe(
			(response: any) => {
				this.schoolList = response;

				// if(this.schoolList.length > 0){
				//   this.selectedDetails.SchoolID = this.schoolList[0].SchoolID;
				// }

				this.SchoolLoading = false;

				this.loadDynamicGroups();
				this.loadAlertList();
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	private loadDynamicGroups() {
		this.GroupLoading = true;

		var result = this.groupService.loadDynamicGroupsList("", 1);
		result.subscribe(
			(response) => {
				this.dynamicGroupList = response;
				// this.onDynamicGroupSelectChange(this.dynamicGroupList[0].DynamicGroupID);
				// this.selectedDetails.DynamicGroupSelectID = this.dynamicGroupList[0].DynamicGroupID;

				if (this.InitGroup == false && this.dynamicGroupList.length > 0) {
					this.selectedDetails.DynamicGroupSelectID = this.dynamicGroupList[0].DynamicGroupID;
				} else {
					this.InitGroup = false;
				}

				this.GroupLoading = false;

				this.loadDynamicValues();
			},
			(error) => {
				this.GroupLoading = false;
			}
		);
	}

	//Load Dynamic Value Options based on the dynamic group selected
	loadDynamicValues() {
		this.ValueLoading = true;

		//Get information about the dynamic group
		var entry;
		for (var i = 0; i < this.dynamicGroupList.length; i++) {
			if (this.dynamicGroupList[i].DynamicGroupID == this.selectedDetails.DynamicGroupSelectID) {
				entry = this.dynamicGroupList[i];
				break;
			}
		}

		//Call usp_DynamicGroupItemSelectList
		var result = this.groupService.loadDynamicValuesList("", entry.DynamicGroupSQL, this.selectedDetails.SchoolID);
		result.subscribe(
			(response) => {
				this.dynamicValueList = response;

				//
				// Replace value on next load
				//
				if (this.InitValue == false && this.dynamicValueList.length > 0) {
					this.selectedDetails.DynamicValueSelectID = this.dynamicValueList[0].ListID;
				} else {
					this.InitValue = false;
				}

				this.ValueLoading = false;
			},
			(error) => {
				this.ValueLoading = false;
			}
		);
	}

	loadAlertList() {
		this.AlertLoading = true;

		var result = this.groupService.loadAssignStudentsAlerts("", this.selectedDetails.SchoolID, 1, 1);
		result.subscribe(
			(response) => {
				this.alertList = response;
				this.alertList.unshift({
					AlertID: -1,
					Message: "No Alert",
				});
				// this.selectedDetails.AlertSelectID = this.alertList[0].AlertID;

				if ((this.selectedDetails.AlertSelectID <= 0 || this.InitAlert == false) && this.alertList.length > 0) {
					this.selectedDetails.AlertSelectID = this.alertList[0].AlertID;
				} else {
					this.InitAlert = false;
				}

				this.AlertLoading = false;
			},
			(error) => {
				this.AlertLoading = false;
			}
		);
	}

	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////

	EditGroupUpdateClick() {
		this.errorMessage = "";

		if (this.dynamicGroupList.length == 0) {
			this.errorMessage = "Select a different dynamic group";
			return;
		}
		if (this.dynamicValueList.length == 0) {
			this.errorMessage = "Select a different dynamic value";
			return;
		}

		this.Saving = true;

		//Turn exclude into an int
		var exclude = this.selectedDetails.Exclude ? 1 : 0;

		var AlertID: any = this.selectedDetails.AlertSelectID > 0 ? this.selectedDetails.AlertSelectID : -1;

		//Call stored procedure
		var result = this.groupService.EditDynamicGroup(
			"",
			this.selectedDetails.EventDynamicGroupID,
			this.selectedDetails.EventDescriptionID,
			this.selectedDetails.DynamicGroupSelectID,
			this.selectedDetails.SchoolID,
			this.selectedDetails.DynamicValueSelectID,
			AlertID,
			exclude
		);
		result.subscribe(
			(response) => {
				this.Saving = false;

				this.CancelAddGroupClick(1);
			},
			(error) => {
				this.Saving = false;
			}
		);
	}

	CancelAddGroupClick(val) {
		this.ref.close(val);
	}

	///////////////////////////////////

	///////////////////////////////////
	// Events
	///////////////////////////////////

	onDynamicGroupSelectChange(value) {
		this.errorMessage = "";

		this.selectedDetails.DynamicGroupSelectID = value;
		this.loadDynamicValues();
	}
	onSchoolChange(val) {
		this.errorMessage = "";

		this.selectedDetails.SchoolID = val;
		this.loadDynamicGroups();
		this.loadAlertList();
	}

	///////////////////////////////////
}
